import { render, staticRenderFns } from "./stockrelation.vue?vue&type=template&id=84c25f76"
import script from "./stockrelation.vue?vue&type=script&lang=js"
export * from "./stockrelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports